import { useEffect, useState } from 'react';
import './MapDate.css';
const MapDate = ({
    setTypeOfDate,
    typeOfDate,
    translations,
    isFullScreenMode,
}) => {
    const [selectedDate, setSelectedDate] = useState(null);

    const handleTypeClick = (event, type) => {
        const buttons = document.querySelectorAll('.map__date_btn');
        buttons.forEach((button) => button.classList.remove('active'));

        event.target.classList.add('active');

        setTypeOfDate(type);
    };

    useEffect(() => {
        setSelectedDate(typeOfDate);
    }, [typeOfDate]);

    return (
        <div className={isFullScreenMode ? 'map__date_full' : 'map__date'}>
            <div className='map__date_wrapper'>
                <button
                    className={`map__date_btn ${
                        selectedDate === 'Today' || typeOfDate === null
                            ? 'active'
                            : ''
                    }`}
                    onClick={(e) => handleTypeClick(e, 'Today')}
                >
                    {translations.today}
                </button>
                <button
                    className={`map__date_btn ${
                        selectedDate === 'Tomorrow' ? 'active' : ''
                    }`}
                    onClick={(e) => handleTypeClick(e, 'Tomorrow')}
                >
                    {translations.tomorrow}
                </button>
                <button
                    className={`map__date_btn ${
                        selectedDate === 'AfterTomorrow' ? 'active' : ''
                    }`}
                    onClick={(e) => handleTypeClick(e, 'AfterTomorrow')}
                >
                    {translations.afterTomorrow}
                </button>
            </div>
        </div>
    );
};

export default MapDate;
